// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentSuccessPage_wrapper__QoByM","title":"PaymentSuccessPage_title__4GpLJ","subtitle":"PaymentSuccessPage_subtitle__uwZLm","link":"PaymentSuccessPage_link__DXdch"};